import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table, 
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateADDomain, deleteTemplateADDomain, putTemplateADDomain
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentADDomain = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [directoryType, setDirectoryType] = useState<string>("ActiveDirectory");
    const [dataForm] = Form.useForm();

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = () => {
        getTemplateADDomain(templateId).then((res) => {
            if (res.directoryType) {
                setShowTable(2);
                setDirectoryType(res.directoryType);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            putTemplateADDomain(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        })
    }

    const deleteTemplateClick = () => {
        deleteTemplateADDomain(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            getDataInfo();
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("AD Domain")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置AD域提供身份验证等功能")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentADDomain", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ marginLeft: 45 }}>
                        <Form
                            style={{ width: "90%", marginTop: 16 }}
                            layout="vertical"
                            form={dataForm}
                            labelCol={{ span: 20 }}
                            initialValues={{ directoryType: "ActiveDirectory" }}
                        >
                            <Item label={t("Directory Type")} name="directoryType" rules={[{ required: true }]}>
                                <Select onChange={(key: string) => { 
                                    setDirectoryType(key);
                                    if (key === "LDAP") {
                                        dataForm.setFieldsValue({adOrganizationalUnit: null});
                                    }
                                }}>
                                    <Select.Option value="ActiveDirectory">{t("Active Directory")}</Select.Option>
                                    <Select.Option value="LDAP">Open Directory/LDAP</Select.Option>
                                </Select>
                            </Item>

                            <Item label={t("Host Name")} name="hostName" rules={[{ required: true }]}>
                                <Input />
                            </Item>

                            <Item label={t("用户名")} name="userName" rules={[{ required: true }]}>
                                <Input />
                            </Item>

                            <Item label={t("密码")} name="password" rules={[{ required: true }]}>
                                <Input.Password />
                            </Item>

                            <Item label={t("Client ID")} name="clientID">
                                <Input />
                            </Item>

                            <Item 
                                label={t("AD Organizational Unit")} 
                                name="adOrganizationalUnit" 
                                rules={[{ required: directoryType === "ActiveDirectory" }]} 
                                hidden={directoryType !== "ActiveDirectory"}
                                extra={<><InfoCircleOutlined /> {t("Case sensitive")}</>}
                            >
                                <Input />
                            </Item>
                        </Form>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); gaEvent("templateContentADDomain", "onClick", "addTemplateClick") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentADDomain", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </Row>
        </div>

    </>)
};